import { BusinessStatus } from "enum/common";
import { useLocalStorage } from "hooks/useLocalStorage";
import { useAppDispatch } from "hooks/useRedux";
import { useEffect, useMemo } from "react";
import { useLazyBusinessQuery } from "store/apis/businessApi";
import { setBusiness } from "store/slices/businessSlice";

interface IBusinessHeaderProps {
  selectedBusiness: BusinessType;
}
const BusinessHeader: React.FC<IBusinessHeaderProps> = ({
  selectedBusiness,
}) => {
  const [_, setSelectedBusiness] = useLocalStorage("selectedBusiness", null);

  const dispatch = useAppDispatch();
  const [fetchBusiness, { data, isSuccess, isError }] = useLazyBusinessQuery();
  const businessStatus = useMemo(() => {
    switch (selectedBusiness?.businessStatus) {
      case BusinessStatus.ACTIVATED:
        return <span className="font-medium text-base text-green">Active</span>;
      case BusinessStatus.DE_ACTIVATED:
        return (
          <span className="font-medium text-base text-failed">Not Active</span>
        );
      case BusinessStatus.IN_ACTIVE:
        return (
          <span className="font-medium text-base text-failed">Not Active</span>
        );

      case BusinessStatus.PARTIALLY_DEACTIVATED:
        return (
          <span className="font-medium text-base text-failed">Not Active</span>
        );
      case BusinessStatus.PENDING:
        return (
          <span className="font-medium text-base text-failed">Pending</span>
        );

      default:
        return null;
    }
  }, [selectedBusiness?.businessStatus]);

  useEffect(() => {
    if (data && isSuccess) {
      setSelectedBusiness(data);
      dispatch(setBusiness(data));
    }
  }, [data, isSuccess]);
  return (
    <div className="mb-4">
      <div className="text-darkBlue md:text-3xl text-xl font-medium flex flex-row md:gap-4">
        <div className="">Welcome {selectedBusiness?.name}</div>
      </div>
      <div className="flex gap-2">
        <span className="text-base ">Business Status:</span>
        <span>{businessStatus}</span>
      </div>
    </div>
  );
};

export default BusinessHeader;
